<template>
    <div class="container" style="max-width:800px;">
      <div class="row pt-2 text-start mb-2">
          <div class="col-6">
              <h5>
                  <span class="badge rounded-pill text-dark p-2 px-3" style="background:LightBlue">
                  <b>Payments : ช่องทางการรับชำระเงิน</b>
                  </span>
              </h5>
          </div>
          <div class="col-6">
              <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#exampleModal" @click="newRecord()" style="width:100px;">New</button>
              <!-- <div class="col float-end "> <input class="btn btn-primary" value="New" @click="newRecord()"></div> -->
          </div>
      </div>
      <div class="row ">
        <div class="col-sm">
            <table id="myRoomTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <!-- <th >รหัสคลินิก</th> -->
                    <th>แก้ไข</th>
                    <th>ช่องทางการรับชำระเงิน</th>
                    <th>ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.specimenid" v-bind:data-id="item.specimenid" @click="tableChanged(item)">
                    <!-- <td class="text-start">{{ item.ReqClinicCode }}</td> -->
                    <td class="">
                        <button type="button" class="btn btn-primary btn-sm mx-1" id="Edit" data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</button>
                    </td>
                    <td class="text-start">{{ item.PaymentName }}</td>
                    <td  >
                        <button class="btn btn-danger btn-sm " id="Delete" @click="cancelRecord(item)">Del</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal Form -->
        <div id="exampleModal" class="modal" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">ป้อนชื่อช่องทางการรับชำระเงิน </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" style="background:LightBlue">
                <form id="fmPayment" @submit.prevent="" >
                    <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                    <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                    <input type="text" hidden class="form-control" placeholder="" name="PaymentID" v-model="curRecord.PaymentID" >
                    <div class="row mb-2">
                        <div class="col-8 text-start">
                            <label for="name" class="mr-sm-2 ">ช่องทางการรับชำระเงิน :</label>
                            <input type="text" class="form-control" id="name"  placeholder="ชื่อ*" name="PaymentName" autocomplete="off" v-model="curRecord.PaymentName" required>
                        </div>
                    </div>
                    <br>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Payments1View',
  components: {

  },
  data () {
    return {
      datalists: null,
      curRecord: {},
      action: 'new'
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.Name,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_payment.php',
            data: { PaymentID: item.PaymentID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
            //   self.getData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    },
    getData () {
      MyApiClient.get('getdata/payment_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myRoomTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmPayment').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_payment.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // this.$refs.getData()
            // self.getData()
            self.$emit('onDataChangedEvent')
            // location.reload()
            // this.$router.push('MClinics')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}
</script>

<style>

</style>
